import { login, authenticateToken } from '@appt-digital/frontend-api-lib-wodity'
import localStorageService from '../../../utils/localStorageService'

const loginHandler = async (
  values,
  navigate,
  setAlert,
  setLoading,
  setUser,
  setOrganisations
) => {
  setLoading(true)
  const res = await login(values.username, values.password)
  if (res.name === 'AxiosError') {
    setAlert({
      open: true,
      severity: 'error',
      message: 'Error logging into portal user.',
      action: false,
    })
    setLoading(false)
    return
  }
  setUser(res.data.user)
  setOrganisations(res.data?.user?.organisations)
  localStorageService.set('user', res?.data?.user)
  navigate('/dashboard')
  setLoading(false)
  // navigate('/authenticate', { state: { twoFAToken: req.data.twoFAToken } })
}

const authenticate2fa = async (
  code,
  token,
  navigate,
  setAlert,
  setLoading,
  setUser,
  setOrganisations
) => {
  const res = await authenticateToken({}, { code }, token)
  if (!res?.data) {
    return setAlert({
      open: true,
      severity: 'error',
      message: 'Invalid 2FA, please try again or return to login.',
      action: false,
    })
  }

  // if (!['KPI_ROLE', 'ADMIN_ROLE'].includes(req.data.user.type)) {
  //   setAlert({
  //     open: true,
  //     severity: 'error',
  //     message: 'You do not have permission to access the portal.',
  //     action: false,
  //   })
  //   setLoading(false)
  // }
  setUser(res.data.user)
  setOrganisations(res.data?.user?.organisations)
  localStorageService.set('user', res?.data?.user)
  navigate('/dashboard')
  setLoading(false)
}

export { loginHandler, authenticate2fa }
